import React, { useState, useEffect } from "react";
import jwt_decode from "jwt-decode";
import UTC from "./utc";
import "./dataList.css";
import { fontWeight } from "@mui/system";

function DataList(props) {
  const [data, setData] = useState([]);
  const [credentialSubject, setCredentialSubject] = useState("");

  useEffect(() => {
    setData(jwt_decode(props.details.data.credential.credential).vc);
    setCredentialSubject(
      formatKeys(
        jwt_decode(props.details.data.credential.credential).vc
          .credentialSubject
      )
    );
  }, []);


  const formatKeys = (data) => {
    let formattedData = JSON.stringify(data);
    formattedData = Array.isArray(data) ? [] : {};

    Object.keys(data).forEach((key) => {
      const formattedKey =
        key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, " ");

      if (typeof data[key] === "object" && data[key] !== null) {
        formattedData[formattedKey] = formatKeys(data[key]);
      } else {
        formattedData[formattedKey] = data[key];
      }
    });
    return formattedData;
  };

  function truncateString(id) {
    const maxLength = 20;
    if (id.length > maxLength) {
      const start = id.substr(0, maxLength / 2 - 1);
      const end = id.substr(id.length - maxLength / 2 + 1);
      return `${start}...${end}`;
    }
    return id;
  }

  function isArrayOfStrings(arr) {
    return Array.isArray(arr) && arr.every((item) => typeof item === "string");
  }

  const renderTableRows = (data, level) => {
    return Object.entries(data).map(([key, value]) => {
      if (typeof value === "object") {
        if (Array.isArray(value)) {
          if (isArrayOfStrings(value)) {
            return (
              <React.Fragment key={key}>
                <tr style={{width: "100%", display: "inline-block"}}>
                  <td
                    className="col-1"
                    style={{
                      fontWeight: 400,
                      paddingLeft: "30px",
                    }}
                  >
                    {key}
                  </td>
                  <td className="col-2"></td>
                </tr>
                {value.map((item, index) => {
                  return (
                    <React.Fragment key={index}>
                      <tr>
                        <td className="col-1"></td>
                        <td className="col-2">{item}</td>
                      </tr>
                    </React.Fragment>
                  );
                })}
              </React.Fragment>
            );
          } else {
            const formattedKey =
                key.charAt(0).toUpperCase() +
                key.slice(1).replace(/_/g, " ");
            return (
              <React.Fragment key={key}>
                <tr style={{width: "100%", display: "inline-block"}}>
                  <td className="col-1">{formattedKey}</td>
                  <td className="col-2"></td>
                </tr>
                {value.map((item, index) => (
                  <React.Fragment key={index}>
                    {renderTableRows(item, 1)}
                  </React.Fragment>
                ))}
              </React.Fragment>
            );
          }
        } else {
          const formattedKey =
            key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, " ");
          return (
            <React.Fragment key={key}>
              <tr style={{width: "100%"}}>
                <td className="col-1">{formattedKey}</td>
                <td className="col-2"></td>
              </tr>
              {renderTableRows(value, 1)}
            </React.Fragment>
          );
        }
      } else {
        let levelPadding = 10 + level * 20;
        let fontWeight;
        if (levelPadding > 10) fontWeight = 400;

        const formattedKey =
          key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, " ");

        let formattedValue = value;
        return (
          <tr style={{width: "100%"}}>
            <td
              className="col-1"
              style={{
                fontWeight: fontWeight,
                paddingLeft: levelPadding + "px",
              }}
            >
              {formattedKey}
            </td>
            <td style={{maxWidth:"100%"}} className="col-2"><p style={{margin: "0", whiteSpace: "initial", overflowWrap: "break-word", width: "100%"}}>{formattedValue ? formattedValue : "/"}</p></td>
          </tr>
        );
      }
    });
  };

  return (
    <div className="datalist-container">
      <div className="messages">
        <h2>Credential details</h2>
      </div>
      <table className="table">
        <tbody>
          <tr>
            <td className="col-1">Credential type</td>
            <td className="col-2">{props.credentialData.credential_title}</td>
          </tr>
          {/*  {Object.entries(credentialSubject).map(([key, value]) => (
            <tr key={key}>
              <td className="col-1">{key}</td>
              <td className="col-2">{value}</td>
            </tr>
          ))} */}
          {renderTableRows(credentialSubject)}
          <tr>
            <td className="col-1">Issuer</td>
            <td className="col-2">{props.credentialData.issuer_title} </td>
          </tr>
          <tr>
            <td className="col-1">Valid from</td>
            <td className="col-2">
              <UTC utc={data.issuanceDate} />
            </td>
          </tr>
          {/*  <tr>
            <td className="col-1">Scope</td>
            <td className="col-2">{props.credentialData.credential_type} </td>
          </tr> */}

          {/* {data.id && (
            <tr>
              <td className="col-1">Id</td>
              <td className="col-2">{truncateId(data.id)}</td>
            </tr>
          )} */}
          {/* <tr>
            <td>Type</td>
            {data.type.map((type) => (
              <td>{type}</td>
            ))}
          </tr> */}
        </tbody>
      </table>
    </div>
  );
}

export default DataList;
